import { createStore } from 'vuex'
import donationWidget from './modules/donation-widget'
import campaignWidget from './modules/campaign-widget';
import salesforceSync from './modules/salesforce-sync';

export const store = createStore({
      modules: {
        donationWidget,
        campaignWidget,
        salesforceSync,
      },
})
